import React, { Component } from 'react';

import { Col, Row, Button, Container, Table}  from 'react-bootstrap';

import {Rest} from "../../Helpers/Rest" 
import InfoBlock from "../../Components/InfoBlock/InfoBlock"
import PropTypes from 'prop-types';
import Uploads from "../../Components/Uploads/Uploads"
import Form from "../../Components/Form/Form"

var method = "create";
var id = false;

try{
    var user_data = JSON.parse(localStorage.getItem("user_data"))
}catch{
    var user_data = {}
}


export default class FormContainer extends Component {
    
    state = {
        data:{},
        roles: {}
    }

    componentDidMount = () => {
        method = this.props.match.params.method
        id = this.props.match.params.id

        if(id){
            var rest = new Rest(this)
            rest.request("users", "READ", {id: id}, (res)=>{ 
                this.setState({
                    data: res,
                    roles: res.roles
                })
            })
        }

        
    };

    save = () =>{ 
        this.setState({
            errors: false,
            success: false
        })
        var data = this.state.data
        var rest = new Rest(this)
        var rest_method = "CREATE"
        if(method=="edit"){
            rest_method = "UPDATE"
        }
        if(this.state.uploads){
            data['uploads'] = this.state.uploads.map(u=>u.id)
        }
        data['roles'] = this.state.roles

        rest.request("users", rest_method, data, (res)=>{ 
             if(!res.errors){
                 this.setState({
                     success: ["Saved"]
                 })
                 setTimeout(()=>{
                     window.location.href = "/users/list"
                 }, 500)
             }
        })
    }
    
  render() {
      console.log(this.state)
      console.log(user_data)
      var roles_fields = [  
        {
            name: "admin",
            label: "ADMIN",
            as: "checkbox"
          },
        {
            name: "posts",
            label: "Posts",
            as: "checkbox"
        }, 
        {
            name: "videos",
            label: "Videos",
            as: "checkbox"
        }, 
        {
            name: "galeries",
            label: "Galeries",
            as: "checkbox"
        },  
        {
            name: "users",
            label: "Users",
            as: "checkbox"
        },  
        {
            name: "board_of_directors",
            label: "BOD",
            as: "checkbox"
        },  
        {
            name: "about_company",
            label: "About company",
            as: "checkbox"
        }, 
        {
            name: "feedback",
            label: "Feedback",
            as: "checkbox"
        }, 
        {
            name: "feedback_categories",
            label: "Feedback categories",
            as: "checkbox"
        }, 
        {
            name: "comments_moderator",
            label: "Comments moderator",
            as: "checkbox"
        },
        {
            name: "events",
            label: "Events",
            as: "checkbox"
        },
        {
            name: "restaurants",
            label: "Restaurants",
            as: "checkbox"
        }
        
      ]
 

    return (
        <Container>
            <Row className="mt-3 mb-3">
            <Col>
                <h4>
                    { method==="edit"? "Edit feedback category" : "Add feedback category"}
                </h4>
            </Col>
            </Row>

            {
                this.state.errors && <InfoBlock data={this.state.errors} variant="danger" />
            }
            {
                this.state.success && <InfoBlock data={this.state.success} variant="info" />
            }
            
            <Row className="mt-3 center">
            <Col>
                <Row className="d-flex justify-content-center">
                    <Col>
                        <h4>Details</h4>
                        <Form
                            fields = {
                              [ 
                                {
                                  name: "status",
                                  label: "Status",
                                  as: "select",
                                  options: [
                                    { label: '', value: ''},
                                    { label: 'active', value: "active"},
                                    { label: 'non active', value: "non active"},
                                    { label: 'deleted', value: "deleted"}
                                  ]
                                }, 
                                {
                                  name: "name",
                                  label: "Name"
                                }, 
                                {
                                  name: "cardholder",
                                  label: "Cardholder"
                                }, 
                                {
                                  name: "login",
                                  label: "Login"
                                }, 
                                {
                                  name: "password",
                                  label: "Password",
                                  type: "password",
                                  autocomplete: "off"
                                }, 
                                {
                                  name: "email",
                                  label: "Email"
                                },
                                {
                                  name: "public_emails",
                                  label: "Public Emails (email1, email2)"
                                },
                                {
                                  name: "phone",
                                  label: "Private phone"
                                },
                                {
                                  name: "public_phones",
                                  label: "Public phones (phone1, phone2, phone3)"
                                },
                                {
                                  name: "member_number",
                                  label: "Member number"
                                },
                                {
                                  name: "position",
                                  label: "Position (Post)"
                                },
                                {
                                  name: "department",
                                  label: "Department"
                                },   
                              ]
                            }
                            store_to={"data"}
                            _this = {this}
                        /> 
                    </Col>
                    <Col>
                            <h4>Roles (for WebUsers)</h4>
                            <Form
                                fields = {roles_fields}
                                store_to={"roles"}
                                _this = {this}
                            /> 
                    </Col>
                </Row> 

                <Button className="btn-block" variant="dark" onClick={this.save}>
                            Save
                        </Button>
            </Col>
        </Row>

        </Container>
    );
  }
}



FormContainer.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string,
            method: PropTypes.string
        })
    }), 
}